import { status } from '../../helpers'

const geteCommerceStoreDefaultState = () => {
  return {
    loadShopDetails: status.INITIALIZED,
    shopDetails: {
      bannerImage: { url: '' },
      logoImage: { url: '' },
      favicon: { url: '' }
    },
    updatingShop: false,
    creatingStore: false,
    enablingDisablingShop: false,
    openSideBar: false,
    loadPublicStore: status.INITIALIZED,
    publicStore: {},
    publicStoreProducts: [],
    loadStoreProductVariants: status.INITIALIZED,
    storeProduct: {},
    storeProductVariants: [],
    storeVariantImages: [],
    storeVariantsDictionary: [],
    storeVariantsTypes: [],
    storeVariantsColors: [],
    storeVariantsSizes: [],
    selectedProductVariants: [],
    productStoreNotFound: false,
    loadingSuggestedProduct: status.INITIALIZED,
    suggestedProducts: [],
    cartStore: {},
    showAddedToCartNotification: false,
    loadStoreCart: status.INITIALIZED,
    isAddingItemToCart: false,
    isRemovingItemFromCart: false,
    isUpdatingItemFromCart: false,
    shippingAddressFormRollUp: false, // setted to true to continue the flow
    settingShippingAddress: false,
    paymentDetails: {
      cardName: '',
      isCardNumberComplete: false,
      isCVCComplete: false,
      isExpDateComplete: false
    },
    differentBillingAddress: {},
    useDifferentBillingAddress: false,
    isCreatingPaymentIntent: false,
    paymentIntent: {},
    connectingStripe: false,
    shopStats: null,
    loadShopStats: status.INITIALIZED,
    loadingOrders: status.INITIALIZED,
    loadingProductImages: status.INITIALIZED,
    creatingProductImages: status.INITIALIZED,
    updatingProductVariants: false,
    productVariants: null,
    productAttributes: null,
    shopOrders: {
      metrics: null,
      pagination: {
        count: 0,
        totalCount: 0,
        totalPages: 0
      },
      orders: []
    },
    loadingOrder: false,
    orderDetails: null,
    loadingShopPayouts: status.INITIALIZED,
    shopPayouts: {
      metrics: null,
      payouts: [],
      pagination: {
        count: 0,
        totalCount: 0,
        totalPages: 0
      }
    },
    exportingOrder: false,
    exportingPayout: false,
    storeProducts: [],
    loadingProducts: false,
    loadingCheckDnsStatus: false,
    dnsStatus: null,
    fetchingGiftCards: false,
    creatingGiftCard: false,
    deletingGiftCards: false,
    giftCards: [],
    giftCardsTotalCount: 0,
    selectAllGiftCards: false,
    selectedGiftCards: []
  }
}

export default geteCommerceStoreDefaultState
